import {Component, OnInit}        from '@angular/core';
declare var $: any;
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PlanService} from './plan.service';
import {Plan} from './plan';
import {MenuService} from '../menu/menu.service';
import {Menu} from '../menu/menu';
import {LoginService} from '../login/login.service';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'plan',
    template: require('../../app/plan/plan.component.html'),
    styles: [require('../../app/plan/plan.component.css')]
})
export class PlanComponent implements OnInit {
    plan: Plan;
    idSeleccionado;
    active: any;
    deshabilitar: boolean;
    permisos: any;
    menus: Menu[];

    constructor(private planService: PlanService,
                private menuService: MenuService,
                private permisoService: PermisoService,
                private loginService: LoginService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Perdir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("plan").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        })

        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/plan/planTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>"
                },
                "mkt": function (column, row) {
                    return row.mkt == true ? "Sí" : "No"
                },
                "alarmas_rango": function (column, row) {
                    return row.alarmas_rango == true ? "Sí" : "No"
                }
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        })
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Inicializar banderas para resetear forms
        this.active = true;
        //Inicializar
        this.plan = new Plan();
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;

        //Cargar menus
        this.menuService.getMenus()
            .subscribe(menus => {
                this.menus = menus;
            });
    }

    ngOnDestroy() {
    }

    agregar() {
        //Inicializo variables
        this.plan = new Plan();
        this.deshabilitar = false;
        $("#modalPlan").modal("show");
        //Reseteo form para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    modificar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco plan
                this.planService
                    .getPlan(this.idSeleccionado)
                    .subscribe(plan => {
                        this.plan = plan;
                    });
                this.deshabilitar = false;
                $("#modalPlan").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco plan
                this.planService
                    .getPlan(this.idSeleccionado)
                    .subscribe(plan => {
                        this.planService.delete(plan).subscribe(() => $("#grid-data").bootgrid("reload"));

                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco plan
                this.planService
                    .getPlan(this.idSeleccionado)
                    .subscribe(plan => {
                        this.plan = plan;
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                $("#modalPlan").modal("show");

            }
        }
    }

    save() {

        this.planService
            .save(this.plan)
            .subscribe((plan) => {
                this.plan = plan;
                //Inicializo variables
                this.plan = new Plan();
                console.log(this.plan);
                //Ocultar modal
                $("#modalPlan").modal("hide");
                //Reseteo formplan para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

    isMenuSelected(menuId: string): boolean {
        return this.plan.menus && this.plan.menus.includes(menuId);
    }

    toggleMenu(menuId: string, event: any): void {
        if (!this.plan.menus) {
            this.plan.menus = [];
        }

        if (event.target.checked) {
            if (!this.plan.menus.includes(menuId)) {
                this.plan.menus.push(menuId);
            }
        } else {
            const index = this.plan.menus.indexOf(menuId);
            if (index > -1) {
                this.plan.menus.splice(index, 1);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/plan/plan.component.ts